var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pagination"},[_c('button',{class:[
      'pagination__change-page',
      'previous-page',
      { 'pagination__change-page--disabled': _vm.isFirstPage } ],attrs:{"disabled":_vm.isFirstPage,"aria-disabled":_vm.isFirstPage,"title":"前往上一頁"},on:{"click":function($event){return _vm.$emit('update:getUpdatedArticles', {
        category: _vm.category,
        page: _vm.pages.current_page - 1,
      })},"keypress":function($event){return _vm.$emit('update:getUpdatedArticles', {
        category: _vm.category,
        page: _vm.pages.current_page - 1,
      })}}},[_vm._v("上一頁")]),_c('nav',{attrs:{"aria-label":"頁數切換區"}},[_c('ul',{staticClass:"pagination__pages"},_vm._l((_vm.pagination),function(item,index){return _c('li',{key:index},[_c('span',{staticClass:"u-hidden"},[_vm._v("第")]),_c('button',{class:[
            'pagination__page',
            { 'pagination__page--now': _vm.getIsCurrentPage(item.value) } ],attrs:{"title":("第" + (item.value) + "頁"),"disabled":_vm.getIsCurrentPage(item.value),"aria-disabled":_vm.getIsCurrentPage(item.value),"aria-current":_vm.getIsCurrentPage(item.value)},on:{"click":item._handleClick,"keypress":item._handleClick}},[_vm._v(_vm._s(item.value))]),_c('span',{staticClass:"u-hidden"},[_vm._v("頁")])])}),0)]),_c('button',{class:[
      'pagination__change-page',
      'next-page',
      { 'pagination__change-page--disabled': _vm.isLastPage } ],attrs:{"disabled":_vm.isLastPage,"aria-disabled":_vm.isLastPage,"title":"前往下一頁"},on:{"click":function($event){return _vm.$emit('update:getUpdatedArticles', {
        category: _vm.category,
        page: _vm.pages.current_page + 1,
      })},"keypress":function($event){return _vm.$emit('update:getUpdatedArticles', {
        category: _vm.category,
        page: _vm.pages.current_page + 1,
      })}}},[_vm._v("下一頁")])])}
var staticRenderFns = []

export { render, staticRenderFns }